import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

import L, { LatLngTuple } from 'leaflet'

import 'leaflet/dist/leaflet.css'

import { Heading6 } from '~/theme/utils/typography'
import { processEnv } from '~/utils/env'

import { MAPBOX_LINK } from '~/constants'
import { gt } from '~/locale'
import Button from '~/shared/atoms/Button'

import { PopupContainer, PopupTitle } from './MapShards'
import { MapItem, MapViewProps } from './MapView'

export const mapPinIcon = L.icon({
  iconUrl: '/assets/svg/map-pin.svg',
  iconSize: [46, 54],
  iconAnchor: [23, 54],
})

export const getBounds = (items: MapItem[]): L.LatLngBounds => {
  const formattedItems = items.map(item => [item.latitude, item.longitude] as LatLngTuple)
  const bounds = new L.LatLngBounds(formattedItems)
  return bounds
}

const TOKEN = processEnv.MAPBOX_TOKEN
const ATTRIBUTION_SNIPPET =
  '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>'

const MapContent = ({ items }: MapViewProps) => {
  const center = getBounds(items).getCenter()

  return (
    <MapContainer center={center} scrollWheelZoom zoom={13}>
      <TileLayer attribution={ATTRIBUTION_SNIPPET} url={MAPBOX_LINK + TOKEN} />
      {items.map(item => (
        <Marker key={item.name} position={[item.latitude, item.longitude]} icon={mapPinIcon}>
          {item.name && item.description && (
            <Popup>
              <PopupContainer>
                <PopupTitle>{item.name}</PopupTitle>
                <Heading6>{item.description}</Heading6>
                {item.detailsHref && (
                  <Button
                    as='a'
                    label={gt.tp('MapBox', 'Check Details')}
                    href={item.detailsHref}
                    color='orange'
                    height='small'
                    width='full'
                    target='_blank'
                  />
                )}
              </PopupContainer>
            </Popup>
          )}
        </Marker>
      ))}
    </MapContainer>
  )
}

export default MapContent
